/**
 * Contains utilities for strings
 * @class StringUtils
 */
export default class StringUtils {
  /**
   * Pads a string with a specific character.
   * @function pad
   * @memberof StringUtils
   * @param  {string} pad     Character to pad with
   * @param  {string} str     Source string to pad
   * @param  {boolean} padLeft True for left padding
   * @return {string}           The padded string.
   */
  static pad(pad, str, padLeft) {
    if (typeof str === 'undefined') {
      return pad;
    }
    if (str.length >= pad.length) {
      return str;
    }
    if (padLeft) {
      return (pad + str).slice(-pad.length);
    }
    return (str + pad).substring(0, pad.length);
  }

  /**
   * Capitalize the first letter and lowercase all others.
   * @param  {string} str Input string
   * @return {string}     Capitalized version of the input
   */
  static capitalize(str) {
    if (str) {
      return str.toLowerCase().replace(/\b\w/g, m => m.toUpperCase());
    }
    return '';
  }

  static camelize(str) {
    return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match, index) => {
      if (+match === 0) return '';
      return index === 0 ? match.toLowerCase() : match.toUpperCase();
    });
  }
}



// WEBPACK FOOTER //
// ./app/util/stringUtils.js